module.exports = __webpack_public_path__ + "assets/Pilzerkrankungen.409d02e8.png";